import { captureException } from '@sentry/react';

import { serverRpc } from '~/modules/remote-mic/network/client';
import { keyStrokes } from '~/modules/remote-mic/network/messages';

let exceptionCaptured = false;

export function vibrate() {
  try {
    navigator?.vibrate?.(100);
  } catch (e) {
    if (!exceptionCaptured) {
      captureException(e, { level: 'warning' });
      exceptionCaptured = true;
    }
  }
}

export const onPress = (key: keyStrokes) => () => {
  vibrate();
  void serverRpc.input.keystroke(key);
};

// A held arrow's repeats do not buzz: a 100ms vibration every 125ms is a continuous hum rather than
// a run of taps. The flash and the rim arc still fire, so a repeat is seen without being felt.
export const onRepeat = (key: keyStrokes) => () => {
  void serverRpc.input.keystroke(key);
};

export const activateControl = (name: string) => {
  vibrate();
  void serverRpc.input.activateControl(name);
};

export const setControlValue = (name: string, value: string) => {
  vibrate();
  void serverRpc.input.setControlValue(name, value);
};
